<!-- context form background should be default white.
     theme color can override as well as a background-image.
-->
@if (useFullViewPointBackground) {
  <section
    class="use-background-image background-image-attributes view-point-background"
    [class.full-page-background]="fullPageBackgroundNotTwelveColumn"
    [style.background-image]="fullViewPointBackgroundImageUrl">
      <ng-container *ngTemplateOutlet="compositeFormContent"></ng-container>
  </section>
} @else {
  <ng-container *ngTemplateOutlet="compositeFormContent"></ng-container>
}
<ng-template #compositeFormContent>
  @if (contextForm) {
    <section #contextContext
        [style.background-image]="contextFormBackgroundImageUrl"
        class="{{contextFormClasses}}"
    >
      <lm-form-content-form #LMContextForm
          [class.personalize-header]="!useContextFormBackgroundImage ? personalize : false"
          [class]="contextFormColorClass"
          [class.light-context-form]="lightContextForm"
          [class.is-alabaster]="isAlabaster"
          [formSpec]="contextForm.busFormSpec"
          [formOptions]="formOptions"
          [specFields]="specFields"
          [placeHolder]="placeHolder"
          [layout]="contextForm.busFormSpec.busFormLayoutSpec.layout"
          [model]="model"
          [isInOverlay]="isInOverlay"
          (fieldEvent)="onFieldEvent($event)"
      ></lm-form-content-form>
    </section>
  }

  <div #flexContent
      soho-busyindicator
      [text]="' '"
      [blockUI]="true"
      [displayDelay]="20"
      [timeToComplete]="this.uiLoadingIndicatorTimeout"
      [transparentOverlay]="true"
      [ngStyle]="{'margin-left': showContextFormOnSide ? '0' : null, 'height': use100HeightContainer ? '100%' : 'auto'}"

      class="lm-composite-content-area"
  >
    @if (hasTabs) {
      <div soho-tabs #sohoTabsComponent
          class="{{contextFormColorClass}}"
          [class.light-context-form]="lightContextForm"
          [class.is-personalizable]="usePersonalizableTabs"
          [ngClass]="[ isInOverlay ? 'lm-flyout-tabs-bg' : '']"
          [alternate]="useAlternateTabs"
          attr.data-automation-id="{{this.tabsetAutomationId}}"
          [attributes]="formPanelTabAttributes"
          [headerTabs]="usePersonalizableTabs"
          [verticalResponsive]="useVerticalTabs"
          [moduleTabsTooltips]="useVerticalTabs"
          [class.horizontal]="!useVerticalTabs"
          [class.sticky-tabs]="!useVerticalTabs && !onSubForm && !isInOverlay"
          [class.overlay-sticky-tabs]="isInOverlay"
          [class.has-breadcrumbs]="hasBreadcrumbs"
          [class.hide-title-bar]="isHideTitleBar"
          [vertical]="useVerticalTabs"
          disableAutoUpdatedCall="true"
          (activated)="onTabActivated($event)"
      >
        <div soho-tab-list-container [verticalScrolling]="useVerticalTabs">
          <ul soho-tab-list>
              @for (panel of panels; track panel.id; let i = $index) {
                <li
                    soho-tab
                    [disabled]="!panel.isValid"
                    [selected]="panel.selected"
                    [hidden]="panel.hidden"
                >
                  <a soho-tab-title
                      attr.id="{{!testVersion1 ? panel.id + tabIdSuffix : null}}"
                      attr.data-automation-id="lm-{{panel.automationId}}-tab"
                      tabId="{{panel.id}}"
                      attr.data-index="{{i}}"
                  >{{panel.title}}</a>
                </li>
              }
            </ul>
        </div>
      </div>
      <div soho-tab-panel-container #tabPanelContainer
           [style.margin-bottom]="'0px'"
           [style.height]="tabPanelContainerHeight"
           [class.tabContainerHideBorder]="hideBorder">
        <!--
          NOTE: DO NOT use display block here, the tabs control uses
          display to pop the panels in and out.
        -->
        @for (panel of panels; track panel.id) {
          <div soho-tab-panel
              tabId="{{panel.id}}"
              [ngClass]="{'panelTextMargin': panel.panelHeader || panel.panelText, 'has-vertical-tab': verticalTabs}"
          >

            <!-- Displays panel header and panel text -->
            @if (panel.panelHeader || panel.panelText) {
              <lm-form-panel-text
                  [panelHeader]="panel.panelHeader"
                  [panelText]="panel.panelText"
                  [specFields]="specFields"
                  [model]="model"
              ></lm-form-panel-text>
            }

            @switch (panel.type) {
              @case ('form') {
                <lm-form-panel-form #compositeComponent
                    [formSpec]="panel.formSpec"
                    [layout]="panel.layout"
                    [formOptions]="formOptions"
                    [specFields]="specFields"
                    [placeHolder]="placeHolder"
                    [model]="model"
                    [initialized]="useLazyLoadForm === false || panel.initialized === true ? true : false"
                    [hideBusyIndicator]="useLazyLoadForm === false || panel.initialized === true ? true : false"
                    [hasPanelText]="panel.panelHeader || panel.panelText ? true : false"
                    [panelId]="panel.id"
                    [isInOverlay]="isInOverlay"
                    [activatedTabChanged]="activatedTabChanged"
                    (fieldEvent)="onFieldEvent($event)"
                ></lm-form-panel-form>
              }
              @case ('formlist') {
                <lm-form-panel-list #compositeComponent
                    [panelId]="panel.id"
                    [activated]="panel.activated"
                    [listSpec]="panel.listSpec"
                    [placeHolder]="placeHolder"
                    [fromDataView]="fromDataView"
                    [specialActions]="panel.specialActions"
                    [implementsCartView]="formSpec.busFormSpec.implementsCartView"
                    [formContextOnLeft]="formSpec.busFormSpec.showContextFormOnLeft"
                    [isInOverlay]="isInOverlay"
                    [isArchiveData]="panel.busFormPanel?.isArchiveData"
                    (formPanelContentLoaded)="onFormPanelContentLoaded($event)"
                    (contentModified)="onContentModified($event)"
                    (updateToolbarStateEvent)="onUpdateToolbarStateEvent()"
                    (sendContextMessageEvent)="onSendContextMessageEvent($event)"
                    (specialActionToolbarButtonEvent)="onSpecialActionToolbarButtonEvent($event)"
                    (panelTransactionEvent)="onPanelTransactionEvent($event)"
                    (drillAroundEvent)="onDrillAroundEvent($event)"
                ></lm-form-panel-list>
              }
              @case ('multilist') {
                <lm-form-panel-multilist #compositeComponent
                    [activated]="panel.activated"
                    [panelId]="panel.id"
                    [sectionSpecs]="panel.sections"
                    [placeHolder]="placeHolder"
                    [fromDataView]="fromDataView"
                    [specFields]="specFields"
                    [isInOverlay]="isInOverlay"
                    (formPanelContentLoaded)="onFormPanelContentLoaded($event)"
                    (contentModified)="onContentModified($event)"
                    (updateToolbarStateEvent)="onUpdateToolbarStateEvent()"
                    (sendContextMessageEvent)="onSendContextMessageEvent($event)"
                    (specialActionToolbarButtonEvent)="onSpecialActionToolbarButtonEvent($event)"
                    (panelTransactionEvent)="onPanelTransactionEvent($event)"
                    (drillAroundEvent)="onDrillAroundEvent($event)"
                    [hasPanelText]="panel.panelHeader || panel.panelText ? true : false"
                ></lm-form-panel-multilist>
              }
              @case ('templateform') {
                <lm-form-panel-template #compositeComponent
                    [activated]="panel.activated"
                    [busFormPanel]="panel.busFormPanel"
                    [formSpec]="panel.formSpec"
                    [layout]="panel.layout"
                    [formOptions]="formOptions"
                    [model]="model"
                    [placeHolder]="placeHolder"
                    [specFields]="panel.formSpec.busFormSpec.fields"
                    [fromDataView]="fromDataView"
                    (formPanelContentLoaded)="onFormPanelContentLoaded($event)"
                    (contentModified)="onContentModified($event)"
                    (fieldEvent)="onFieldEvent($event)"
                    [panelId]="panel.id"
                ></lm-form-panel-template>
              }
              @case ('independentform') {
                <lm-form-panel-independentform #compositeComponent
                    [activated]="panel.activated"
                    [formSpec]="panel.formSpec"
                    [placeHolder]="placeHolder"
                    [fromDataView]="fromDataView"
                    (formPanelContentLoaded)="onFormPanelContentLoaded($event)"
                    (contentModified)="onContentModified($event)"
                    [panelId]="panel.id"
                ></lm-form-panel-independentform>
              }
              @case ('actionis') {
                <lm-form-panel-actionis #compositeComponent
                    [activated]="panel.activated"
                    [formSpec]="panel.formSpec"
                    [targetAction]="panel.busFormPanel.actionFullName"
                    [placeHolder]="placeHolder"
                    [fromDataView]="fromDataView"
                    (formPanelContentLoaded)="onFormPanelContentLoaded($event)"
                    (contentModified)="onContentModified($event)"
                    [panelId]="panel.id"
                ></lm-form-panel-actionis>
              }
              @case ('url') {
                <lm-form-panel-url #compositeComponent
                    [ngStyle]="{'height': '100%'}"
                    [url]="panel.url"
                    [panelId]="panel.id"
                    [placeHolder]="placeHolder"
                    [fromDataView]="fromDataView"
                    [activated]="panel.activated"
                    (panelTransactionEvent)="onPanelTransactionEvent($event)"
                ></lm-form-panel-url>
              }
              @case ('wfm') {
                <lm-form-panel-url #compositeComponent
                     [isWFM]="true"
                     [ngStyle]="{'height': '100%'}"
                     [url]="panel.url"
                     [panelId]="panel.id"
                     [placeHolder]="placeHolder"
                     [fromDataView]="fromDataView"
                     [activated]="panel.activated"
                     (panelTransactionEvent)="onPanelTransactionEvent($event)"
                ></lm-form-panel-url>
              }
              @case ('dashboard') {
                <lm-form-panel-dashboard #compositeComponent
                    [formUrlInfo]="formUrlInfo"
                    [panels]="panel.dashBoardPanes"
                    [panel]="panel"
                    [model]="model"
                    [panelVisibilityUpdateTimeStamp]="panelVisibilityUpdateTimeStamp"
                    [columns]="panel.dashboardColumns"
                    [specFields]="specFields"
                    [placeHolder]="placeHolder"
                    [fromDataView]="fromDataView"
                    [refreshAfterInit]="false"
                    [isFlyoutContent]="isInOverlay"
                    (contentModified)="onContentModified($event)"
                    (panelTransactionEvent)="onPanelTransactionEvent($event)"
                    (drillAroundEvent)="onDrillAroundEvent($event)"
                    (fieldEvent)="onFieldEvent($event)"
                ></lm-form-panel-dashboard>
              }
              @default {
                <lm-form-panel-notfound #compositeComponent></lm-form-panel-notfound>
              }
            }
          </div>
        }
      </div>
    }
    @else {
      @if (singlePanel) {
        @switch (singlePanel.type) {
          @case ('form') {
            <div [style.height]="tabPanelContainerHeight">
              <lm-form-panel-form #compositeComponent
                  class="single-panel"
                  [activated]="true"
                  [initialized]="true"
                  [formSpec]="singlePanel.formSpec"
                  [layout]="singlePanel.layout"
                  [formOptions]="formOptions"
                  [specFields]="specFields"
                  [placeHolder]="placeHolder"
                  [model]="model"
                  [panelId]="singlePanel.id"
                  (fieldEvent)="onFieldEvent($event)"
              ></lm-form-panel-form>
            </div>
          }
          @case ('formlist') {
            <div [style.height]="tabPanelContainerHeight">
              <lm-form-panel-list #compositeComponent
                  class="single-panel"
                  [usedInCartView]="usedInCartView"
                  [panelId]="singlePanel.id"
                  [activated]="true"
                  [listSpec]="singlePanel.listSpec"
                  [placeHolder]="placeHolder"
                  [fromDataView]="fromDataView"
                  [specialActions]="singlePanel.specialActions"
                  [formContextOnLeft]="formSpec.busFormSpec.showContextFormOnLeft"
                  [isInOverlay]="isInOverlay"
                  [isArchiveData]="singlePanel.busFormPanel?.isArchiveData"
                  (formPanelContentLoaded)="onFormPanelContentLoaded($event)"
                  (contentModified)="onContentModified($event)"
                  (updateToolbarStateEvent)="onUpdateToolbarStateEvent()"
                  (sendContextMessageEvent)="onSendContextMessageEvent($event)"
                  (specialActionToolbarButtonEvent)="onSpecialActionToolbarButtonEvent($event)"
                  (panelTransactionEvent)="onPanelTransactionEvent($event)"
                  (drillAroundEvent)="onDrillAroundEvent($event)"
              ></lm-form-panel-list>
            </div>
          }
          @case ('multilist') {
            <div [style.height]="tabPanelContainerHeight">
              <lm-form-panel-multilist #compositeComponent
                  class="single-panel"
                  [activated]="true"
                  [panelId]="singlePanel.id"
                  [sectionSpecs]="singlePanel.sections"
                  [placeHolder]="placeHolder"
                  [fromDataView]="fromDataView"
                  [isInOverlay]="isInOverlay"
                  (formPanelContentLoaded)="onFormPanelContentLoaded($event)"
                  (contentModified)="onContentModified($event)"
                  (updateToolbarStateEvent)="onUpdateToolbarStateEvent()"
                  (sendContextMessageEvent)="onSendContextMessageEvent($event)"
                  (specialActionToolbarButtonEvent)="onSpecialActionToolbarButtonEvent($event)"
                  (panelTransactionEvent)="onPanelTransactionEvent($event)"
                  (drillAroundEvent)="onDrillAroundEvent($event)"
                  [hasPanelText]="singlePanel.panelHeader || singlePanel.panelText ? true : false"
              ></lm-form-panel-multilist>
            </div>
          }
          @case ('templateform') {
            <div [style.height]="tabPanelContainerHeight">
              <lm-form-panel-template #compositeComponent
                  class="single-panel"
                  [activated]="true"
                  [busFormPanel]="singlePanel.busFormPanel"
                  [formOptions]="formOptions"
                  [model]="model"
                  [placeHolder]="placeHolder"
                  [specFields]="singlePanel.formSpec.busFormSpec.fields"
                  [fromDataView]="model.getData()"
                  [layout]="singlePanel.layout"
                  [formSpec]="singlePanel.formSpec"
                  (formPanelContentLoaded)="onFormPanelContentLoaded($event)"
                  (contentModified)="onContentModified($event)"
                  [panelId]="singlePanel.id"
              ></lm-form-panel-template>
            </div>
          }
          @case ('independentform') {
            <div [style.height]="tabPanelContainerHeight">
              <lm-form-panel-independentform #compositeComponent
                  class="single-panel"
                  [activated]="true"
                  [formSpec]="singlePanel.formSpec"
                  [placeHolder]="placeHolder"
                  [fromDataView]="fromDataView"
                  (formPanelContentLoaded)="onFormPanelContentLoaded($event)"
                  (contentModified)="onContentModified($event)"
                  [panelId]="singlePanel.id"
              ></lm-form-panel-independentform>
            </div>
          }
          @case ('actionis') {
            <div [style.height]="tabPanelContainerHeight">
              <lm-form-panel-actionis #compositeComponent
                  class="single-panel"
                  [activated]="true"
                  [formSpec]="singlePanel.formSpec"
                  [targetAction]="singlePanel.busFormPanel.actionFullName"
                  [placeHolder]="placeHolder"
                  [fromDataView]="fromDataView"
                  (formPanelContentLoaded)="onFormPanelContentLoaded($event)"
                  (contentModified)="onContentModified($event)"
                  [panelId]="singlePanel.id"
              ></lm-form-panel-actionis>
            </div>
          }
          @case ('url') {
            <div [style.height]="tabPanelContainerHeight">
              <lm-form-panel-url #compositeComponent
                  class="single-panel"
                  [url]="singlePanel.url"
                  [placeHolder]="placeHolder"
                  [fromDataView]="fromDataView"
                  [activated]="true"
              ></lm-form-panel-url>
            </div>
          }
          @case ('wfm') {
            <div [style.height]="tabPanelContainerHeight">
              <lm-form-panel-url #compositeComponent
                   class="single-panel"
                   [url]="singlePanel.url"
                   [placeHolder]="placeHolder"
                   [fromDataView]="fromDataView"
                   [activated]="true"
              ></lm-form-panel-url>
            </div>
          }
          @case ('dashboard') {
            <div [style.height]="tabPanelContainerHeight">
              <lm-form-panel-dashboard #compositeComponent
                  [formUrlInfo]="formUrlInfo"
                  [activated]="true"
                  [panel]="singlePanel"
                  [panels]="singlePanel.dashBoardPanes"
                  [model]="model"
                  [panelVisibilityUpdateTimeStamp]="panelVisibilityUpdateTimeStamp"
                  [columns]="singlePanel.dashboardColumns"
                  [specFields]="specFields"
                  [placeHolder]="placeHolder"
                  [fromDataView]="fromDataView"
                  [refreshAfterInit]="true"
                  [isFlyoutContent]="isInOverlay"
                  (contentModified)="onContentModified($event)"
                  (panelTransactionEvent)="onPanelTransactionEvent($event)"
                  (drillAroundEvent)="onDrillAroundEvent($event)"
                  (fieldEvent)="onFieldEvent($event)"
              ></lm-form-panel-dashboard>
            </div>
          }
          @default {
            <div [style.height]="tabPanelContainerHeight">
              <lm-form-panel-notfound #compositeComponent></lm-form-panel-notfound>
            </div>
          }
        }
      }
      @if (formSpec.busFormSpec.implementsDashBoardView) {
        <div class="lm-panel-dashboard"
             [style.height]="tabPanelContainerHeight">
          @if (formSpec.useTwelveColumnGrid) {
            <lm-twelve-column-grid #dashboardViewComponent
             [formUrlInfo]="formUrlInfo"
             [dashboardPanels]="panels"
             [panelVisibilityUpdateTimeStamp]="panelVisibilityUpdateTimeStamp"
             [model]="model"
             [specFields]="specFields"
             [placeHolder]="placeHolder"
             [fromDataView]="fromDataView"
             [isFlyoutContent]="isInOverlay"
             (contentModified)="onContentModified($event)"
             (panelTransactionEvent)="onPanelTransactionEvent($event)"
             (drillAroundEvent)="onDrillAroundEvent($event)"
             (fieldEvent)="onFieldEvent($event)"
            ></lm-twelve-column-grid>
          } @else {
            <lm-dashboard-view #dashboardViewComponent
                [formUrlInfo]="formUrlInfo"
                [dashboardPanels]="panels"
                [panelVisibilityUpdateTimeStamp]="panelVisibilityUpdateTimeStamp"
                [model]="model"
                [columns]="formSpec.busFormSpec.dashboardColumns"
                [specFields]="specFields"
                [placeHolder]="placeHolder"
                [fromDataView]="fromDataView"
                [refreshAfterInit]="true"
                [isFlyoutContent]="isInOverlay"
                (contentModified)="onContentModified($event)"
                (panelTransactionEvent)="onPanelTransactionEvent($event)"
                (drillAroundEvent)="onDrillAroundEvent($event)"
                (fieldEvent)="onFieldEvent($event)"
            ></lm-dashboard-view>
          }
        </div>
      }
    }


  </div>
</ng-template>
